import { Mapper } from "lib/api"
import * as containmentStatus from "enums/containmentStatus"
import { ContainmentStatusDTO } from "models"

export class ContainmentStatusMapper extends Mapper<
	ContainmentStatusDTO,
	containmentStatus.ContainmentStatus
> {
	protected override customMapping(
		source: ContainmentStatusDTO
	): containmentStatus.ContainmentStatus {
		return containmentStatus
			.GetStatusNameFromId(source.id)
			.AndThen((name) => {
				return containmentStatus.GetStatusFactory(name).Map((factory) => factory(source))
			})
			.Expect("Unknown status ID")
	}
}

export function New(): ContainmentStatusMapper {
	return new ContainmentStatusMapper()
}
